import { Check, ArrowUpRight, CreditCard } from "lucide-react";
import { B2B } from "@/constants/testIds";
import { startStripeCheckout } from "@/lib/payments";

export const TIERS = [
  {
    key: "starter", name: "Starter", subtitle: "Small teams · up to 25", price: "$1,200", unit: "/quarter",
    testid: B2B.pricingStarter, checkoutKey: "b2b_starter",
    features: ["Access to 4 core modules", "1 Kindle site license", "Slack / Teams onboarding kit", "Quarterly office hours"],
  },
  {
    key: "team", name: "Team", subtitle: "Departments · 25 – 250", price: "$4,800", unit: "/quarter", featured: true,
    testid: B2B.pricingTeam, checkoutKey: "b2b_team",
    features: ["All 8 healing modules", "Bulk paperback discount (30%)", "Live pre-shift workshop (2/quarter)", "Manager training playbook", "Anonymous impact dashboard"],
  },
  {
    key: "enterprise", name: "Enterprise", subtitle: "Companies · 250+", price: "Custom", unit: "",
    testid: B2B.pricingEnterprise,
    features: ["White-labeled portal for staff", "Custom module authored for your industry", "On-site executive workshops", "Dedicated wellness strategist", "Quarterly board-level report"],
  },
];

const TierCard = ({ t, index, userId, onSelect }) => (
  <div
    data-testid={t.testid}
    className={`col-span-12 md:col-span-4 p-8 md:p-12 relative ${index < TIERS.length - 1 ? "md:border-r border-[#E7DFD5]" : ""} ${index > 0 ? "border-t md:border-t-0 border-[#E7DFD5]" : ""} ${t.featured ? "bg-[#F5EFEB]" : ""}`}
  >
    {t.featured && <div className="absolute top-6 right-6 section-tag text-[#B45309]">Most chosen</div>}
    <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#78716C] mb-3">{t.subtitle}</div>
    <div className="font-display text-4xl md:text-5xl mb-6">{t.name}</div>
    <div className="flex items-baseline gap-2 mb-8">
      <span className="font-display text-5xl md:text-6xl text-[#1C1917]">{t.price}</span>
      {t.unit && <span className="font-mono text-xs text-[#78716C]">{t.unit}</span>}
    </div>
    <ul className="space-y-3 mb-8">
      {t.features.map((f) => (
        <li key={f} className="flex items-start gap-3 text-sm text-[#44403C]">
          <Check size={16} className="text-[#B45309] mt-1 shrink-0" strokeWidth={1.5} />
          <span>{f}</span>
        </li>
      ))}
    </ul>
    <div className="flex flex-col gap-3">
      <a href="#quote" onClick={() => onSelect(t.key)} className={t.featured ? "btn-ember text-sm w-full justify-center" : "btn-outline text-sm w-full justify-center"}>
        Request {t.name}
        <ArrowUpRight size={16} />
      </a>
      {t.checkoutKey && (
        <button
          onClick={() => startStripeCheckout(t.checkoutKey, userId)}
          data-testid={`b2b-pay-${t.key}`}
          className="text-center font-mono text-[10px] tracking-[0.25em] uppercase text-[#78716C] hover:text-[#B45309] transition-colors inline-flex items-center justify-center gap-2"
        >
          <CreditCard size={13} /> Pay now — {t.price}{t.unit}
        </button>
      )}
    </div>
  </div>
);

export const B2BTierGrid = ({ userId, onSelect }) => (
  <div className="grid grid-cols-12 border border-[#E7DFD5]">
    {TIERS.map((t, i) => <TierCard key={t.key} t={t} index={i} userId={userId} onSelect={onSelect} />)}
  </div>
);
